/* eslint-disable react/jsx-props-no-spreading */
import PropTypes from 'prop-types';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import styled from 'styled-components';
import { Spacings } from '@styles/index';

const StyledRadio = styled(Radio)`
  padding: 0px;
  padding-right: ${Spacings.SPACING_4B};
  :hover {
    background-color: ${({ theme }) => theme.colors.white};
  }
  color: ${({ theme }) => theme.colors.fontGrey};
`;

const Label = styled(FormControlLabel)`
  margin-left: 0px;
`;

const RadioButton = (props) => {
  const { label } = props;
  const radioButton = (
    <StyledRadio
      disableFocusRipple
      disableTouchRipple
      disableRipple
      size="small"
      color="default"
      {...props}
    />
  );
  if (label) return <Label control={radioButton} label={label} />;
  return radioButton;
};

export default RadioButton;

RadioButton.propTypes = {
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.objectOf(PropTypes.any)
  ])
};

RadioButton.defaultProps = {
  label: ''
};
